class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.grid = document.getElementById('product-grid');
    this.observer = null;
    this.initObserver();
  }

  initObserver() {
    const options = {
      root: null,
      rootMargin: '0px 0px 400px 0px', // Preload before reaching bottom
      threshold: 0
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.button.classList.contains('loading')) {
          this.loadNextPage();
        }
      });
    }, options);

    this.observer.observe(this);
  }

  loadNextPage() {
    this.button.classList.add('loading');
    this.button.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const url = this.button.dataset.href;

    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceGrid = html.getElementById('product-grid');
        const sourceItems = sourceGrid.querySelectorAll('.grid__item');
        
        if (this.grid) {
            sourceItems.forEach(item => {
                this.grid.appendChild(item);
            });
        }

        const nextButton = html.querySelector('.load-more-btn');
        if (nextButton && nextButton.dataset.href) {
            this.button.dataset.href = nextButton.dataset.href;
            this.button.classList.remove('loading');
            this.button.querySelector('.loading-overlay__spinner').classList.add('hidden');
        } else {
            this.button.classList.add('hidden');
            this.observer.disconnect();
        }
      })
      .catch(e => {
        console.error(e);
        this.button.classList.remove('loading');
        this.button.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }
}

customElements.define('load-more', LoadMore);
